import React from "react"

export default function ExceptOutlook({ children }) {
  const opener = "<!--[if !mso]><!-->"
  const closer = "<!--<![endif]-->"

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: opener }} />
      {children}
      <div dangerouslySetInnerHTML={{ __html: closer }} />
    </>
  )
}
